import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import HeroSection from "../../../layout/HeroSection";
import Listing from "../../lessons/Listing";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchToolsTrade } from "../../../redux/action/moreAction";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../../../components/other/Loader";

const ToolsOfTheTrade = () => {
  const dispatch = useDispatch();
  const { toolsTradeList, isLoading } = useSelector(
    (state) => state?.moreReducer
  );
 
  useEffect(() => {
    dispatch(fetchToolsTrade());
  }, []);


  if (isLoading) {
    return <Loader />;
  }
  return (
    <>
      <div>
        <Header />
        <HeroSection
          label={<h1 class="mb-3">{"Tools of the Trade"}</h1>}
          breadcrumbItems={[
            { name: "Home", path: `${pageRoutes?.home}/` },
            {
              name: "Tools of the Trade",
              path: `${pageRoutes?.home}/`,
            },
          ]}
        />

        <Listing contentData={toolsTradeList} />

        <Footer />
      </div>
    </>
  );
};

export default ToolsOfTheTrade;
